// @ts-nocheck

import * as Types from '../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type AddCustomFieldDefinitionMutationVariables = Types.Exact<{
  customFieldDefinition: Types.CustomFieldDefinitionModelInput;
}>;

export type AddCustomFieldDefinitionMutation = { createCustomFieldDefinition: { uid: string } };

export const AddCustomFieldDefinitionDocument = gql`
    mutation AddCustomFieldDefinition($customFieldDefinition: CustomFieldDefinitionModelInput!) {
  createCustomFieldDefinition(customFieldDefinition: $customFieldDefinition) {
    uid
  }
}
    ` as unknown as DocumentNode<AddCustomFieldDefinitionMutation, AddCustomFieldDefinitionMutationVariables>;
